import { Button } from "@heroui/react";
import type { ErrorComponentProps } from "@tanstack/react-router";

import { useLanguage, useUserInfos } from "@onesolution/hooks";
import { reportErrorToSlack } from "@onesolution/utils/reportToSlack";
import { useEffect, useState } from "react";

export default function ErrorBoundary(props: ErrorComponentProps) {
	const { error } = props;
	const { t } = useLanguage();
	const userData = useUserInfos();
	const [reported, setReported] = useState(false);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <trigger only once>
	useEffect(() => {
		if (!reported) {
			setReported(true);
			reportErrorToSlack(
				"FRONT CLIENT ERROR",
				{ user: userData },
				{
					message: error.message,
					name: error.name,
					cause: error.cause,
					stack: error.stack,
				},
			);
		}
	}, []);

	return (
		<div className="size-full flex flex-col justify-center items-center gap-5">
			<div className="flex flex-col justify-center items-center gap-1">
				<h1>{t("errorApp")}</h1>
				{import.meta.env.DEV && <p>{error.message}</p>}
			</div>

			<Button
				color="primary"
				variant="shadow"
				onPress={() => window.location.reload()}
			>
				{t("basic.reload")}
			</Button>
		</div>
	);
}
